<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="customer.name" :subtext="subtext" :header="dateFormatted" @select="select" />
		<LayoutTableCommonPartRaw class="text-center px-2" width="35" @select="select">
			<input type="checkbox" :checked="(selecteds.type == 'all' || selecteds.ids.includes(customer.id))" :disabled="selecteds.type == 'all'" class="form-check-input">
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartInfo :info="extras" />
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import moment from 'moment';

	export default {
		emits: ['select'],
		props: {
			customer: Object,
			selecteds: Object
		},
		setup(props, { emit }) {
			const dateFormatted = computed(() => moment(props.customer.created_at).format('DD/MM/YYYY'));
			const select = () => emit('select', props.customer);

			const subtext = computed(() => {
				let data = [];

				data.push((!props.customer.group) ? 'Sin grupo asignado' : props.customer.group.name);
				data.push((!props.customer.active_user) ? 'Sin vendedor asignado' : props.customer.active_user.name);

				return data.join(' · ');
			});

			const extras = computed(() => {
				let data = [];

				if('last_buy' in props.customer.extras) {
					data.push(`<b>Última compra:</b> ${moment(props.customer.extras.last_buy).fromNow()}`);
				}

				if('total_buy' in props.customer.extras) {
					let numberFormat = new Intl.NumberFormat('es-ES');
					data.push(`<b>Compra total:</b> $ ${numberFormat.format(props.customer.extras.total_buy)}`);
				}

				if('birthdate' in props.customer.extras) {
					data.push(`<b>Cumpleaños:</b> ${moment(props.customer.extras.birthdate).format('dddd D [de] MMMM')}`);
				}

				if(data.length == 0) {
					data.push('Sin información adicional');
				}

				return data.join('<br />');
			});

			return { dateFormatted, select, subtext, extras };
		}
	}
</script>